<template>
  <!-- 线上诊断  -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form class="demo-form-inline" label-position="right" label-width="110px" :model="formState">
          <el-form-item label="订单号">
            <el-input v-model="customerId" placeholder="请输入订单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="学生姓名">
            <el-input v-model="searchStudent" placeholder="请输入学生姓名" clearable @clear="inputListener"></el-input>
          </el-form-item>
          <el-form-item label="微信号">
            <el-input v-model="formState.customerWx" placeholder="请输入微信号" clearable @clear="inputListener"></el-input>
          </el-form-item>

          <el-form-item label="老师姓名">
            <el-select @clear="handleClear" clearable filterable  id="teacher" class="select" v-model="searchTeacherId"
              placeholder="请选择老师">
              <el-option v-for="teacher in teachers" :key="teacher.value" :value="teacher.value" :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="成交状态">
            <el-select clearable filterable  class="select" v-model="formState.orderType" placeholder="请选择成交状态">
              <!-- <el-option label="" value=""></el-option> -->
              <el-option label="定金" value="1"></el-option>
              <el-option label="全额" value="2"></el-option>
              <el-option label="分期" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker clearable style="width: 100%" value-format="yyyy-MM-dd" v-model="createTime" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="客资来源">
            <el-select @clear="handleClear" v-model="searchSource" clearable filterable   placeholder="请选择客资来源">
              <el-option v-for="item in sources" :key="item.sourceId" :label="item.sourceName"
                :value="item.sourceId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线上诊断老师">
            <el-select multiple v-model="selectTeacher"  filterable  clearable @clear="handleClear" placeholder="请选择线上诊断老师">
              <el-option v-for="item in teacherList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客资来源负责人">
            <el-select v-model="searchSourcesPeople" filterable  clearable @clear="handleClear" placeholder="请选择客资来源负责人">
              <el-option v-for="item in sourcesPeople" :key="item.sourcepeopleId" :label="item.sourcepeopleName"
                :value="item.sourcepeopleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="诊断状态">
            <el-select clearable class="select" filterable  v-model="formState.statusId" placeholder="请选择诊断状态">
              <el-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>









          <!-- <el-form-item label="客资来源">
                <el-select v-model="sourceName" clearable @clear="handleClear" placeholder="请选择客资来源">
                  <el-option v-for="item in sourcesList" :key="item.sourceId" :label="item.sourceName"
                    :value="item.sourceId"></el-option>
                </el-select>
              </el-form-item> -->

          <el-form-item label="预约时间">
            <el-date-picker style="width: 100%" clearable value-format="yyyy-MM-dd" v-model="formState.diagnosisOnlineTime"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>


          <el-form-item label="个人账号:">
            <el-select v-model="inputAcount" clearable filterable   placeholder="请选择个人账号">
              <el-option v-for="item in optionsList" :key="item.name" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button @click="handleClearList" icon="el-icon-close" size="small" class="btns">清除</el-button>
            <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
          </el-form-item>

        </el-form>
        <!-- 查询列表 -->
        <el-table :header-cell-style="{
          background: '#fafafa'
        }" :data="list" border height="700" style="width: 100%;position: relative;">
          <el-table-column prop="customerId" label="订单号" :resizable="false"></el-table-column>
          <el-table-column prop="customerWx" label="微信" :resizable="false" width="150"></el-table-column>
          <el-table-column prop="regionName" label="所在地域" :resizable="false"></el-table-column>
          <!-- <el-table-column prop="customerAccount" label="个人账号" width="120"></el-table-column> -->
          <el-table-column prop="customerAccountName" label="个人账号" width="110" :resizable="false">
              <template slot-scope="scope">
                <span v-if="scope.row.customerAccountName === '10015'">苏芮</span>
                <span v-else-if="scope.row.customerAccountName === '10014'">王威</span>
                <span v-else>{{ scope.row.customerAccountName ? scope.row.customerAccountName : scope.row.customerAccount  }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="customerStudent" label="学生姓名" :resizable="false"></el-table-column>
          <el-table-column prop="parentPhoneNumber" label="家长电话" width="130"></el-table-column>
          <el-table-column label="诊断状态" :resizable="false">
            <template slot-scope="scope">
              <span v-if="scope.row.statusId === 1">待诊断</span>
              <span v-if="scope.row.statusId === null">待诊断</span>
              <span v-if="scope.row.statusId === 2">已诊断</span>
            </template>
          </el-table-column>

          <el-table-column label="成交状态" header-align="center" :resizable="false">
            <template slot-scope="scope">
              <span>{{ scope.row.orderType == 1 ? "定金" : scope.row.orderType == 2 ? "全额" : scope.row.orderType == 3 ? "分期"
                : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="老师" :resizable="false">
            <template slot-scope="scope">
              <span v-if="scope.row.customerTeacherid === 1">小单老师</span>
              <span v-if="scope.row.customerTeacherid === 2">大单老师</span>
              <span v-if="scope.row.customerTeacherid === 3">刘老师</span>
              <span v-if="scope.row.customerTeacherid === 4">杨老师</span>
            </template>
          </el-table-column>
          <el-table-column prop="diagnosisTeacherName" label="线上诊断老师" :resizable="false" width="120">
          </el-table-column>
          <el-table-column prop="sourcepeopleName" label="来源负责人" :resizable="false" width="150">
          </el-table-column>
          <el-table-column prop="sourceName" label="客资来源" :resizable="false">
          </el-table-column>
          <el-table-column prop="diagnosisOnlineTime" label="创建时间" width="180" :resizable="false"></el-table-column>
          <el-table-column label="预约时间" width="180" :resizable="false">
            <template slot-scope='scope'>
              <span>{{ scope.row.onlineTime }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" prop="address" header-align="center" align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.customerId)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 图片弹层 -->
        <el-dialog :visible.sync="previewDialogVisible" width="60%" class="custom-dialog">
          <img :src="previewImageUrl" style="max-width: 100%; max-height: 100%;" />
        </el-dialog>
        <!--         分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="requestParameters.currentpage" :page-size="requestParameters.pagesize"
          layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>
        <diagnosis-view ref="diagnosisView" @refreshOrder="refreshOrder"></diagnosis-view>
        <!--        成单编辑弹窗-->
        <!--        <order-update ref="orderUpdate"></order-update>-->
        <!--        &lt;!&ndash;        成单客资详情页面&ndash;&gt;-->
        <!--        <order-detail ref="orderDetail" @refreshOrder="refreshOrder"></order-detail>-->
      </el-card>
    </div>
  </div>
</template>
<script>
import apiBaseUrl from "../../../config/api";
import axios from "axios";
import DiagnosisView from "./DiagnosisView.vue";
// import CustomerUpdOrDet from './components/CustomerUpdOrDet.vue';
// import OrderUpdate from "./OrderUpdate.vue";
// import OrderDetail from "./OrderDetail.vue";

export default {
  components: { DiagnosisView },
  // components: {
  //   OrderDetail,
  //   OrderUpdate, //成单编辑
  // },
  data () {
    return {
      selectTeacher: [],
      customerId: "",//订单号
      sourceName: "",//搜索框客资来源
      list: [],
      address: "",
      total: 0, //总条数
      url: "",
      statusList: [
        {
          value: 1,
          label: "待诊断"
        },
        {
          value: 2,
          label: "已诊断"
        },
      ],
      teachers: [
        {
          value: 1,
          label: "小单老师"
        },
        {
          value: 2,
          label: "大单老师"
        },
        {
          value: 3,
          label: "刘老师"
        },
        {
          value: 4,
          label: "杨老师"
        }
      ], //；老师
      teacherList: [],
      formState: {
        customerWx: "", // 微信号
        statusId: "",   // 诊断状态
        orderType: '',  // 成交状态
        sourceName: "", // 客资来源
        diagnosisOnlineTime: "", // 创建时间
      },
      sourcesList: [], // 客源
      createTime: "",
      sources: [], //客资来源列表
      sourcesPeople: [], //客资来源负责人列表
      searchStudent: "", //输入的学生姓名
      searchTeacherId: "", //选择的老师姓名
      searchSource: "", //选择来源
      searchSourcesPeople: "", //选择的来源负责人
      searchStatus: "", //选择的状态
      searchAdd: "", //选择添加方式
      selectedState: "",
      searchType: "", //选择类型
      stateList: [],
      d: [],
      studentName: "", // 保存学生姓名的变量
      deleteCustomerId: null,
      searchKeyword: "",
      requestParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1 //当前显示页码
      },
      showEdit: false, // 控制弹层显示/隐藏的变量
      srcList: [], // 预览图像的原始链接列表
      previewImageUrl: "", // 当前预览图像的链接
      previewDialogVisible: false, // 大图预览对话框是否可见
      inputAcount:"",
      optionsList:[
        {name:"王威", id:'10014' },
        {name:"苏芮", id:'10015' },
      ],
    };
  },
  created () {
    this.getList();
    this.getDataSourse();
    this.getDataSoursePeople();
    this.getTeachers()
  },
  mounted () {
    axios
      .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
      .then((response) => {
        this.sourcesList = response.data.data.list;
      })
      .catch((error) => {
        console.error(error);
      });

  },
  methods: {
    //老师列表
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teacherList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    //查询列表
    getList () {
      const data = {
        customerId: this.customerId,
        page: this.requestParameters.currentpage,
        limit: this.requestParameters.pagesize,
        onlineStatus: 1,
        customerAccount: "",
        studentName: this.searchStudent, //要查询的学生姓名
        teacherId: this.searchTeacherId,
        searchSource: this.searchSource, //来源
        searchSourcesPeople: this.searchSourcesPeople,
        customerState: this.searchStatus, //选择状态
        customerIsactive: this.searchAdd, //选择添加方式
        customerType: this.searchType,
        onlineTime: this.createTime,
        type: 2,
        customerWx: this.formState.customerWx,
        statusId: this.formState.statusId,
        orderType: this.formState.orderType,
        sourceName: this.formState.sourceName,
        diagnosisOnlineTime: this.formState.diagnosisOnlineTime,
        selectTeacher: this.selectTeacher,
        account:this.inputAcount,
      };

      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        data.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          data.customerAccount = JSON.parse(teacher).adminNo;
        }
      }
      axios
        .post(`${apiBaseUrl}/orderCustomer/list`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.list = response.data.data.records;
          for (let i = 0; i < response.data.data.records.length; i++) {
            response.data.data.records[i].onlineTime = `${JSON.parse(response.data.data.records[i].onlineTime)[0]} ${JSON.parse(response.data.data.records[i].onlineTime)[1]} ${JSON.parse(response.data.data.records[i].onlineTime)[2]}`
          }
          this.total = response.data.data.total; // 更新总条数
        })
        .catch(error => {
          console.log(error);
        });
    },
    //客资来源
    getDataSourse () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.sources = response.data.data.list;
        })
        .catch(error => {
          console.error(error);
        });
    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.sourcesPeople = response.data.data.list;
        })
        .catch(error => {
          console.error(error);
        });
    },
    //查询状态
    handleStateChange (row) {
      const { customerId, customerState } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstateupdate`, {
          customerId: customerId,
          customerState: customerState
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          console.log(response);
          // 更新数据成功后，进行相应的操作
          this.stateList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "客资状态保存成功",
              type: "success",
              duration: 1000
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "客资状态未保存",
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //添加方式：主动/被动
    handleAddChange (row) {
      const { customerId, customerIsactive } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerisactiveupdate`, {
          customerId: customerId,
          customerIsactive: customerIsactive
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          console.log(response);
          // 更新数据成功后，进行相应的操作
          this.addList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "添加方式保存成功",
              type: "success",
              duration: 1000
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "添加方式保存未保存",
              type: "error",
              duration: 1000
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    resetSuccesType (customer) {
      customer.type = 1;
    },

    //删除
    deleteCustomer (customerId) {
      this.$confirm("确定删除该条客资信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios
            .delete(
              `${apiBaseUrl}/customerinformation/customerdelete/${customerId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
            )
            .then(response => {
              console.log(response);
              if (response.data.code === 200) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                //失败
                this.$message.error("删除失败");
              }
            })
            .catch(error => {
              console.log(error);
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    //图片预览
    handlePreview (url) {
      if (!this.srcList.includes(url)) {
        this.srcList.push(url);
      }
      this.previewImageUrl = url;
      this.previewDialogVisible = true;
    },
    //分页
    handleSizeChange (pageSize) {
      this.requestParameters.pagesize = pageSize;
      if (this.requestParameters.page === 1) {
      }
      this.getList(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.currentpage = newPage;
      this.getList();
    },
    //清除
    handleClearList () {
      this.inputAcount = ""
      this.selectTeacher = []
      this.customerId = ""
      this.searchStudent = ""; // 清除学生姓名
      this.searchTeacherId = ""; // 清除老师
      this.searchSource = ""; // 清除客资
      this.searchSourcesPeople = "";
      this.createTime = "";//创建日期
      this.formState = {
        customerWx: "", // 微信号
        statusId: "",   // 诊断状态
        orderType: '',  // 成交状态
        sourceName: "", // 客资来源
        diagnosisOnlineTime: "", // 预约时间
      },
        this.getList()
    },
    // 搜索
    handleSearch () {
      this.requestParameters.currentpage = 1;
      this.getList();
    },
    //修改学生弹窗
    showEditDialog () {
      this.edit(); // 在打开编辑弹层时调用获取数据的方法
      this.showEdit = true;
    },
    closeEditDialog () {
      this.showEdit = false;
    },
    // 编辑表单
    saveEditForm () {
      // 保存编辑表单的逻辑
      // 将编辑后的数据提交给后端 API
      // ...
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, {
          customerStudent: this.studentName,
          customerId: this.customerId
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 1000
            });
            this.showEdit = false;
            this.getList();
          } else {
            this.$message({ error: "修改失败", type: "error", duration: 1000 });
          }
        })
        .catch(
          error =>
            function () {
              this.$message({
                error: "修改失败",
                type: "error",
                duration: 1000
              });
            }
        );
    },
    refreshOrder () {
      this.getList();
    },
    //编辑
    edit (customerId) {
      this.$nextTick(() => {
        this.$refs.diagnosisView.init(customerId);
      });
    },
    detail (customerId) {
      this.$nextTick(() => {
        this.$refs.orderDetail.init(customerId);
      });
    },
    //回显学生姓名并修改
    getStudent () {
      const data = {
        customerStudent: "",
        customerId: ""
      };
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate${data}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    //成交状态
    handleChangeType (customer) {
      this.$confirm(
        `确定修改客资成交状态吗？<span style="color: red">成交状态只可修改一次!</span>`,
        `提示`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          this.$refs.orderUpdate.orderShow(customer);
        })
        .catch(() => {
          customer.type = 1;
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    //导出客资
    handleDownload () {
      // 定义要传递的参数
      const params = {
        customerStudent: "", // 姓名
        customerAccount: "", //账号
        customerWx: this.searchWx, //要查询的微信号
        customerState: this.searchStatus, //选择状态
        customerIsactive: this.searchAdd, //选择添加方式
        customerType: this.searchType
      };
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        params.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          params.customerAccount = JSON.parse(teacher).adminNo;
        }
      }

      axios
        .post(
          `${apiBaseUrl}/customerinformation/customerinformationexceloutput`,
          params,
          { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
         } // 设置responseType为'blob'以接收二进制数据
        )
        .then(response => {
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel"
          }); // 从响应中获取Blob对象
          const downloadLink = document.createElement("a"); // 创建一个下载链接
          downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
          downloadLink.download = "客资信息.xlsx"; // 设置下载文件的文件名
          // console.log(response);

          downloadLink.click(); // 触发下载
        })
        .catch(error => {
          console.log(error);
        });
    },
    //点击添加客资跳转客资收集
    addCustomer () {
      this.$router.push("/customercollect");
    },
    inputListener () {
      this.getList()
    },
    handleClear () {
      this.getList()
    },
    handleDateClear () {
      this.createTime = null;  // 清空 createTime 的值   // 如果 createTime 不为空，则获取数据
      this.getList();
    }
  }
};
</script>

<style scoped>
.demo-form-inline {
  flex-wrap: wrap;
  display: flex;
}

.demo-form-inline .el-form-item {
  margin-right: 20px;
}

.cor {
  border-radius: 5px;
  margin-top: 10px;
  background-color: #f4f4f5;
}

.num {
  padding: 10px;
  color: #ccc;
  font-size: 13px;
}

.el-icon-info {
  margin-right: 5px;
}

.cg {
  /* flex: 1; */
  margin-top: 20px;
  white-space: nowrap;
}

.page {
  position: fixed;
  bottom: 0;
  width: 80%;
}

.custom-dialog {
  overflow: auto;
}

.parent-container {
  position: relative;
}

.pagination-container {
  position: absolute;
  bottom: 10px;
}

.btn {
  opacity: 0;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.el-dialog {
    width: 70% !important;
    position: relative;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/OnlineDiagnosis.vue